module.exports = __webpack_public_path__ + "static/media/wallpaper5.71d7d593.jpg";